import { createFileRoute } from '@tanstack/react-router'

import CreateKotaKabupatenPage from '@/components/pages/backoffice/_klb-penyuluh/_kotakab/containers/CreatePage'

export const Route = createFileRoute(
  '/_backoffice/klb-penyuluh/kotakab/create'
)({
  component: CreateKotaKabupatenPage
})
